import router from "@/router";

/*
    check if user needs to reauthenticate and reroute path to login-page
*/
export default async function redirectToLogin ({next}:any){
    await router.replace("/login")
    return next();
}
